import Context from 'managers/Context';
import { persistTokens, refreshToken } from 'services';
import { ensureAbsoluteHttpUrl, resolveExternalCrudIframeUrl } from 'utils/externalCrud';

export const appendParentOrigin = (src) => {
    if (!src) return null;

    try {
        const url = new URL(src);
        url.searchParams.set('parentOrigin', window.location.origin);
        return url.toString();
    } catch {
        return src;
    }
};

export const resolveHostIframeSrc = ({ entityConfig, entityKey, failedToInit, initContext }) => {
    if (failedToInit) return null;

    return appendParentOrigin(resolveExternalCrudIframeUrl(entityKey, initContext, entityConfig));
};

export const getRuntimeAuthToken = (fallbackToken) => {
    return (
        Context?.config?.token || window.sessionStorage.getItem('fm_token') || fallbackToken || null
    );
};

export const getRuntimeRefreshToken = () => {
    return Context?.config?.refreshToken || window.sessionStorage.getItem('refreshToken') || null;
};

export const refreshRuntimeAuthToken = async (fallbackToken) => {
    const currentRefreshToken = getRuntimeRefreshToken();
    if (!currentRefreshToken) return getRuntimeAuthToken(fallbackToken);

    const tokens = await refreshToken(currentRefreshToken);
    persistTokens(tokens);
    return tokens?.token || getRuntimeAuthToken(fallbackToken);
};

export const getEmbedEntityId = (value) => {
    if (value == null) return null;

    const parsedValue = Number.parseInt(value, 10);
    return Number.isNaN(parsedValue) ? undefined : parsedValue;
};

export const normalizeEmbedInitContext = (entityKey, initialPayload) => {
    const apiBaseUrl = ensureAbsoluteHttpUrl(
        initialPayload?.apiBaseUrl || initialPayload?.api_base_url,
    );

    return {
        entityKey,
        ...(initialPayload || {}),
        ...(apiBaseUrl ? { apiBaseUrl } : {}),
    };
};

export const createEmbedSessionIds = (initContext = {}) => {
    const createId = () => {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
            return crypto.randomUUID();
        }

        return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    };

    return {
        correlationId: initContext?.correlationId || createId(),
        sessionId: initContext?.sessionId || createId(),
    };
};
